import { render, staticRenderFns } from "./VerifyEmail.vue?vue&type=template&id=aa23da74&scoped=true"
import script from "./VerifyEmail.vue?vue&type=script&lang=ts"
export * from "./VerifyEmail.vue?vue&type=script&lang=ts"
import style0 from "./VerifyEmail.vue?vue&type=style&index=0&id=aa23da74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../DATA/projects/nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa23da74",
  null
  
)

export default component.exports